import { StyleSheet } from 'react-native'

const useStyles = (isTablet) => StyleSheet.create({
  container: {
    paddingHorizontal: isTablet ? 40 : 20
  },
  historyItem: {
    marginVertical: 10
  },
  historyItemCard: {
    borderRadius: 4,
    paddingHorizontal: 20,
    paddingVertical: 5,
    maxWidth: 220,
    marginBottom: 5
  },
  dateTime: {
    flexDirection: 'row'
  },
  date: {
    marginRight: 10
  },
  triangle: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    position: 'absolute'
  },
  rightTriangle: {
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 10,
    borderLeftWidth: 10,
    borderTopColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: 'transparent',
    right: 0
  },
  leftTriangle: {
    borderTopWidth: 0,
    borderRightWidth: 10,
    borderBottomWidth: 10,
    borderLeftWidth: 0,
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    borderLeftColor: 'transparent',
    left: 0
  }
})

export default useStyles
